import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import * as moment from 'moment';
import { Subject, forkJoin, debounceTime, takeUntil, filter } from 'rxjs';
import { UserPermission } from 'src/app/enums/enums';
import { FilterPipe } from 'src/app/pipes/list-filter-pipe/list-filter-pipe';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { AppointmentTypeService } from 'src/app/services/core/appointment-type/appointment-type.service';
import { BillingService } from 'src/app/services/core/billing/billing.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { CsvService } from 'src/app/services/core/csv-service/csv.service';
import { FundingSourceService } from 'src/app/services/core/funding-source/funding-source.service';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { MemberService } from 'src/app/services/core/member/member.service';
import { ServiceAreasService } from 'src/app/services/core/service-areas-service/service-areas.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
import { sweetAlert, sweetAlertWithHtml } from 'src/app/utils/swal';
import { getSkippedItemsHtml } from 'src/app/utils/skipped-alert.utils';
import { timeZone } from 'src/app/utils/utils.common';
@UntilDestroy()

@Component({
  selector: 'app-billing-list',
  templateUrl: './billing-list.component.html',
  styleUrls: ['./billing-list.component.css']
})


export class BillingListComponent {
  isTripDetailModal: boolean = false;
  selectedTrips: any = [];
  bulkPayIds: string[] = [];
  tripId: any;
  isDistributionModal = false;
  search: any;
  trips: any = [];
  preFundingSource: any = {};
  spacetypes: any;
  corporateUsers: any = ''
  preSpacetypes: any = {};
  preServiceAreas: any = {};
  // preMembers: any = {};
  preAppointmentType: any = {};
  preCompanies: any = {};
  preLevelOfService: any = {};
  currentPage = 1;
  totalResults = 0;
  totalPages = 0;
  numberOfRecords = NUMBER_OF_RECORDS
  selectedStatus: any = '';
  todayDate: any = [];
  startDate: any;
  endDate: any;
  levelofservices: any;
  selectedCompany = '';
  companies: any;
  serviceAreas: any;
  selectedServiceArea: any = ''
  selectedSpaceType: any = ''
  cancelTripObj: any;
  memberNotesObj: any;
  fundingSources:any
  isMultiCancelModal = false;
  selectedDropdownIndex: any;
  toggleActionButtons = false;
  isDropdownOpen = false;
  user: any;
  timeZone: any = timeZone;
  currentDate: any = moment().tz(this.timeZone).toISOString()
  tripDistributionModalObj: any;
  singleTrip: any;
  isAutoDistributionModal: any;
  userPermission = UserPermission;
  filterdataList: any = [];
  drivers: any = [];
  preDrivers: any = {};
  vehicles: any = [];
  preVehicles: any = {};
  paramountLoader = {
    isModal: false,
    isLoading: false
  };

  selectedCorporateUser: any = ''
  selectedCorporateObj: any
  preSpaceTypes = {};
  dataList = [];
  signatureModalObj: any;
  tripTrailId: any;
  selectedPaymentStatus: any = '';
  selectedPaymentType: any = '';
  private searchSubject = new Subject<string>();




  constructor(
    private sharedDataService: SharedDataService,
    private serviceArea: ServiceAreasService,
    private credentialService: CredentialService,
    private levelOfService: LosService,
    private appointmentService: AppointmentTypeService,
    // private memberService: MemberService,
    private spaceTypeService: SpaceTypeService,
    private billingService: BillingService,
    private router: Router,
    private csvService: CsvService,
    public permissionService: PermissionService,
    private memberService: MemberService,
    private fundingSourceService :FundingSourceService
  ) {

  }

  ngOnInit(): void {
    this.getUser();
    this.getDrivers();
    this.getFleet();
    this.getFundingSources()
    this.initializeSearch();
  }

  getUser() {
    this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe((data) => {
      if (data) {
        this.user = data;
        if (this.user.timeZone) {
          this.timeZone = this.user.timeZone;
        }
        this.todayDate = [
          moment().tz(this.timeZone).startOf("day"),
          moment().tz(this.timeZone).endOf("day"),
        ];
        this.loadInitialData();
      }

    })
  }

  loadInitialData() {
    const queryparams = {
      limit: 9999,
      isActive: 'true'
    }
    forkJoin({
      companies: this.credentialService.getPicker(queryparams),
      levelOfService: this.levelOfService.getPicker(queryparams),
      appointments: this.appointmentService.getPicker(queryparams),
      spaceTypes: this.spaceTypeService.getPicker(queryparams),
      serviceAreas: this.serviceArea.getPicker(queryparams)
    }).pipe(untilDestroyed(this))
      .subscribe(({ companies, levelOfService, appointments, members, spaceTypes, serviceAreas }: any) => {

        //  Companies
        if (companies?.results?.length) {
          this.companies = companies.results;
          this.preCompanies = this.companies.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }

        //  Level of Service
        if (levelOfService?.results?.length) {
          this.preLevelOfService = levelOfService.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }

        //  Appointments
        if (appointments?.results?.length) {
          this.preAppointmentType = appointments.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }

        //  Space Types
        if (spaceTypes?.results?.length) {
          this.spacetypes = spaceTypes.results;
          this.preSpacetypes = this.spacetypes.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }

        //  serviceAreas
        if (serviceAreas?.results?.length) {
          this.serviceAreas = serviceAreas.results
          this.preServiceAreas = serviceAreas.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }

        //  Trips 
        this.getAllTrips(this.currentPage);
      });
  }

  getAllTrips(page: any) {
    this.clear();
    let queryparams: any = {
      limit: this.numberOfRecords,
      page,
      status: ['completed', 'cancelled'],
      time: [this.todayDate[0].toISOString(), this.todayDate[1].toISOString()],
      sortBy: 'member:asc',
      company: this.user.company.id
    };
    if (this.selectedServiceArea) {
      queryparams.serviceArea = this.selectedServiceArea;
    }
    if (this.selectedPaymentStatus) {
      queryparams.payment = this.selectedPaymentStatus;
    }

    if (this.selectedPaymentType) {
      queryparams.paymentType = this.selectedPaymentType;
    }
    if (this.search) {
      const trimmedSearch = this.search.trim();
      queryparams.search = trimmedSearch;
    }
    this.billingService.getBillingTrips(queryparams)
      .pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data && data.results) {
          this.trips = data.results.map((trip: any) => ({
            ...trip,
            onway: trip.events?.find((e: any) => e.status === 'onway'),
            arrived: trip.events?.find((e: any) => e.status === 'arrived'),
            inProgress: trip.events?.find((e: any) => e.status === 'in_progress'),
            completed: trip.events?.find((e: any) => e.status === 'completed')
          }));
          this.filterdataList = this.trips;
          this.totalPages = data.totalPages;
          this.totalResults = data.totalResults;
        }
      });
  }


  onSelectTrip(trip: any) {
    const index = this.selectedTrips.findIndex((t: any) => t.id === trip.id); // Check if trip is already selected
    if (index > -1) {
      trip.isSelected = false;
      this.selectedTrips.splice(index, 1);
      if (!this.selectedTrips.length) {
        this.isDropdownOpen = false;
      }
    } else {
      trip.isSelected = true;
      this.selectedTrips.push(trip);
      if (this.selectedTrips.length) {
        this.isDropdownOpen = true;
      }
    }
  }

  onSelectAllTrips(event: any) {
    const checked = event.target.checked;
    this.filterdataList.forEach((trip: any) => trip.isSelected = checked);
    this.selectedTrips = checked ? [...this.filterdataList] : [];
    if (this.selectedTrips.length) {
      this.isDropdownOpen = true;
    } else {
      this.isDropdownOpen = false;
    }
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getAllTrips(page);
  }

  opendetailModal(trip: any) {
    this.tripId = trip.id;
  }

  closeModal() {
    this.isDistributionModal = false;
    if (this.singleTrip) {
      this.singleTrip = null;
    }
  }

  onDateChange(event: any) {
    this.todayDate = [
      event[0],
      event[1].endOf("day"),
    ];
    this.currentPage = 1;
    this.getAllTrips(this.currentPage);
  }

  filterTrips(status?: string) {
    this.selectedStatus = status || '';
    this.getAllTrips(this.currentPage);
  }

  clear() {
    this.trips = []
    this.selectedTrips = []
    // this.trip.isSelected = false;
  }

  onServiceAreaChange() {
    this.getAllTrips(this.currentPage);
  }

  onPaymentStatusChange() {
    this.currentPage = 1;
    this.getAllTrips(this.currentPage);
  }

  onPaymentTypeChange() {
    this.currentPage = 1;
    this.getAllTrips(this.currentPage);
  }

  openNotesModal(memberNotes: any) {
    this.memberNotesObj = memberNotes;
  }

  preTripCompany() {
    const previousAssignedCompanies = this.selectedTrips
      .filter((trip: any) => trip.company)
      .map((trip: any) => ({
        company: trip.company,
        tripId: trip.id
      }));
    return previousAssignedCompanies;
  }

  showActionButtons(idx: any) {
    this.selectedDropdownIndex = idx;
    this.toggleActionButtons = true;
  }

  closeActionMenu(evt: any) {
    this.selectedDropdownIndex = -1;
    this.toggleActionButtons = false;
  }

  closeFilterDropDown(evt: any) {
    this.isDropdownOpen = false
  }

  toggleDropdown(event: MouseEvent) {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  getFundingSources() {
    const queryParams = {
      limit: 9999,
      isActive: true
    }
    this.fundingSourceService
      .getPicker(queryParams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.fundingSources = data.results;
          this.preFundingSource = this.fundingSources.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      });
  }

  getDrivers() {
    const queryParams = {
      limit: 9999,
      isActive: true
    }
    this.credentialService
      .getDrivers(queryParams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.drivers = data.results;
          this.preDrivers = this.drivers.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      });
  }

  getFleet() {
    const queryParams = {
      limit: 9999,
      isActive: true
    }
    this.credentialService
      .getAllVehicles(queryParams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.vehicles = data.results;
          this.preVehicles = this.vehicles.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      });
  }

  getSelectedTrips() {
    return this.trips
      .filter((trip: any) => trip.isSelected);
  }

  tripDetailFile() {
    let selectedTrip;
    if (!this.selectedTrips.length)
      selectedTrip = this.trips;
    else
      selectedTrip = this.getSelectedTrips();

    this.csvService.generateTripItineraryReport(selectedTrip, this.todayDate, this.timeZone, this.preLevelOfService, this.preSpacetypes, this.preServiceAreas)
  }

  openBulkPayModal() {
    this.bulkPayIds = this.selectedTrips.map((trip: any) => trip.id);
    this.isDropdownOpen = false;
  }

  onCloseBulkPayModal(data: any) {
    this.bulkPayIds = [];
    if (!data) return;
    this.selectedTrips = [];
    this.getAllTrips(this.currentPage);
    if (data.skippedPayments?.length) {
      sweetAlertWithHtml('Alert', '', 'alert', 'OK', getSkippedItemsHtml(data.skippedPayments, `Batch ${data.batchId}: ${data.createdPayments.length} paid, ${data.skippedPayments.length} skipped.`));
    } else {
      sweetAlert('Success', `Batch ${data.batchId}: ${data.createdPayments.length} payment(s) added`, 'success', 'OK');
    }
  }

  uncheckTrips() {
    this.trips.forEach((trip: any) => trip.isSelected = false);
  }

  openAdjustTrip(event: any) {
    this.router.navigateByUrl(`billing/${event.id}/adjustTrip`);
  }


  downloadRawReport() {
    const selectedTrips = this.getSelectedTrips();
    const filterTrips = this.selectedTrips.length
      ? this.trips.filter((trip: any) => selectedTrips.some((selected: any) => selected.id === trip.id))
      : this.trips;
    const filterTripIds = filterTrips.map((trip: any) => trip.id);
    let queryparams = {
      selectedIds: filterTripIds,
      time: [this.todayDate[0].toISOString(), this.todayDate[1].toISOString()],
    }
    this.billingService.getReportTrips(queryparams)
      .subscribe((trips: any) => {
        if (trips && trips.length) {

          this.filterRawReportTrips(trips);
        }
      });
  }

  openParamountModal() {
    this.selectedTrips = this.trips.filter((trip: any) => trip.isSelected);
    this.paramountLoader.isModal = true;
  }

  filterRawReportTrips(trips: any) {

    this.csvService.generateRawTripReport(
      trips,
      this.todayDate,
      this.timeZone,
    );
  }

  openSignatureModal(trip: any) {
    this.signatureModalObj = trip;
  }

  onCloseSignatureModal(evt: any) {
    if (evt) {
      this.signatureModalObj.signature = evt.signature;
    }
    this.signatureModalObj = null;
  }

  openTripTrails(trip: any) {
    this.tripTrailId = trip.id;
  }

  onSearchInput() {
    this.searchSubject.next(this.search);
  }

  initializeSearch() {
    this.searchSubject
      .pipe(
        debounceTime(500),
        filter((search: any) => !search || search.length >= 3)
      )
      .subscribe(() => {
        this.currentPage = 1;
        this.getAllTrips(this.currentPage);
      });
  }

  ngOnDestroy(): void {
  }

}
